/**
 * Boli Live - Auth Guard Component
 *
 * Protects routes that require authentication.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/stores/auth-store';
import { Loader2 } from 'lucide-react';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized } = useAuthStore();
  const location = useLocation();

  // Show loading while checking auth
  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-400" />
      </div>
    );
  }

  // Redirect to profile/login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/profile" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
